import { TextLayerData } from "../layers/textLayerData.model";
import { BaseSerializer } from "./baseSerializer";

export class TextSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    this._normalizeSource(data);
    const gp = new TextLayerData(data);
    return gp;
  }
}
